<div *ngIf="kanbanTable==true && loader==true" id="kanbanPreview" class="board" cdkDropList [cdkDropListData]="tracks"
     (cdkDropListDropped)="onTrackDrop($event)"
     cdkDropListOrientation="horizontal">
    <div class="row col-sm-12 px-0">
        <div style="padding-left: 20px;padding-right: 18px;" class="col-md-12 col-sm-12 col-lg-12 col-xl-4">
            <div class="container kanban-header kanban-header-purple">
                <div class="media">
                    <div class="media-body"><i class="kanban-header-menu fas fa-ellipsis-v"></i>
                        <h3 class="mt-0 mb-0 kanban-header-label">NOVI</h3>
                        <p class="kanban-header-desc">Zadaci koji su na čekanju: {{tracks[0].tasks.length}}</p>
                    </div>
                </div>
            </div>

            <div class="card-list-content mt-3" cdkDropList [id]="tracks[0].id"
                 [cdkDropListData]="tracks[0].tasks"
                 [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">
                <!--Kanban card -->
                <div *ngFor="let task of tracks[0].tasks" cdkDrag [cdkDragDisabled]="task.track==='ddone'"
                     class="card mb-3 kanban-card"
                     [ngStyle]="{'border': task['validation_returns'] >0  ?'3px solid #f4433685':''}"
                >
                    <div [routerLink]="['/view-task',task._id]"
                         class="card-body">
                        <div class="float-right mt-n1 mb-2" style="width: 100%">
                            <div class="media">
                                <div class="media-body" style="margin-top:2px;">
<span id="projectSpan" *ngIf="task.project !== null"
      class=" badge badge-success project-preview text-wrap">{{task.project.name}}</span>
                                    <span id="projectSpan" *ngIf="task.project === null" title="Dodajte projekat"
                                          class=" badge badge-success project-preview text-wrap ">Nema projekta</span>

                                </div>
                                <app-avatar
                                        [personalStyle]="task.type==='meeting'? 'margin-top:4px;border: 2px solid white;left: 3%;':'margin-top:4px;border:2px solid white'"
                                        [avatarWidth]="30"
                                        [assigned]="assign"
                                        *ngFor="let assign of task.assigned"></app-avatar>

                            </div>
                        </div>
                        <div class="float-right mr-n2">
                        </div>
                        <p style="font-size: 14px;" class="mt-2">{{task.title}}</p>
                        <div class="kanban-card-tags">
<span style="background: #4bc66c" class="badge badge-success ml-1"
      *ngFor="let tag of task.tags">{{tag}}</span>
                        </div>
                    </div>
                    <div
                            class="card-footer no-border bg-transparent kanban-card-attachments no-padding-left text-right no-padding-right">
                        <div id="homethumbs">
                            <div class="wrap">

                                <div class="homethumb">
<span title="Podzadaci"
      (click)="show(task)"
      class="badge badge-info ml-1"
      style="margin-top: 2px;margin-right: 5px;">
<i class="lni lni-list"></i>
    {{task.subtasks.length}}
</span>
                                </div>
                                <div class="homethumb">
<span title="Dokumenti" class="badge badge-success"> <i
        class="lni lni-paperclip"></i> {{task.attachments.length}}</span>
                                </div>
                                <div class="homethumb">
<span title="Komentari" class="badge badge-success ml-1"> <i
        class="lni lni-comments"></i> {{task.comments}}</span>
                                </div>
                                <div class="homethumb">
<span *ngIf="task.dayPast <0" title="Rok je istekao pre {{task.dayPast * -1}} dana"
      class="badge badge-danger ml-1"
      style="margin-top: 2px;pointer-events: none;background: #f4433685;">
{{task.deadline | date: "dd.MM" }}
</span>
                                    <span *ngIf="task.dayPast > 0" title="{{task.dayPast}} dana do kraja roka"
                                          class="badge badge-success ml-1 mr-1"
                                          style="margin-top: 2px;pointer-events: none">
{{task.deadline | date: "dd.MM" }}
</span>
                                    <span *ngIf="task.dayPast == 0" title=" Danas ističe rok."
                                          class="badge badge-info ml-1"
                                          style="margin-top: 2px;pointer-events: none">
{{task.deadline | date: "dd.MM" }}
</span>
                                </div>
                            </div>


                        </div>


                    </div>
                    <div class="col-md-12 col-xs-12 text-right wd-notif-blc-sep-label "
                         style="padding-right: 6px;">Broj: {{task.identifier}}</div>
                    <div *ngIf="task.visibility" class="com-md-12 cursor">
                        <div *ngIf="task.subtasks.length > 0">
                            <div style="max-height: 200px;" [routerLink]="['/view-task', st._id]"
                                 class="well-done-task-subtasks mt-0 col-md-12"
                                 *ngFor="let st of task.subtasks">

                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item no-padding">
                                        <div style="word-break: break-word;margin-top: 3px;"
                                             class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10   px-0">
                                            <i *ngIf="st.status=='todo'"
                                               style="color:#8a9e74"
                                               title="Otvoren"
                                               class="fa fa-list-ul" aria-hidden="true">
                                            </i>
                                            <i style="color:#0085ff" *ngIf="st.status=='inprogress'"
                                               title="U radu"
                                               class="fa fa-spinner" aria-hidden="true">
                                            </i>
                                            <i style="color:#45f02f"
                                               *ngIf="st.status=='ddone'"
                                               title="Završen"
                                               class="fa fa-check-circle" aria-hidden="true">
                                            </i>
                                            <i style="color:#ff1700"
                                               *ngIf="st.status=='canceled'"
                                               title="Otkazan"
                                               class="fa fa-times" aria-hidden="true">
                                            </i>
                                            <i style="color:#ffd600"
                                               *ngIf="st.status=='postponed'"
                                               title="Odložen"
                                               class="fa fa-clock" aria-hidden="true">
                                            </i>
                                            {{st.title}}
                                        </div>
                                        <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 no-padding"
                                             style="margin-bottom: 8px;margin-top:3px">
                                            <app-avatar [avatarWidth]="23" [assigned]="st.assignedUserData[0]">

                                            </app-avatar>
                                        </div>
                                </ul>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div style="padding-left: 20px;padding-right: 18px;" class="col-md-12 col-sm-12 col-lg-12 col-xl-4">
            <div class=" kanban-header kanban-header-orange">
                <div class="media">
                    <div class="media-body"><i class="kanban-header-menu fas fa-ellipsis-v"></i>
                        <h3 class="mt-0 mb-0 kanban-header-label">U RADU</h3>
                        <p class="kanban-header-desc">Zadaci koji su u radu: {{tracks[1].tasks.length}}</p>
                    </div>
                </div>

            </div>

            <div class="card-list-content mt-3" cdkDropList [id]="tracks[1].id"
                 [cdkDropListData]="tracks[1].tasks"
                 [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">
                <div *ngFor="let task of tracks[1].tasks" cdkDrag [cdkDragDisabled]="task.track==='ddone'"
                     class="card mb-3 kanban-card"
                     [ngStyle]="{'border': task['validation_returns'] >0  ?'3px solid #f4433685':''}">
                    <div [routerLink]="['/view-task',task._id]"
                         class="card-body">
                        <div class="float-right mt-n1 mb-2" style="width: 100%">
                            <div class="media">
                                <div class="media-body" style="margin-top:2px;">
<span id="projectSpan" *ngIf="task.project !== null"
      class=" badge badge-success project-preview text-wrap">{{task.project.name}}</span>
                                    <span id="projectSpan" *ngIf="task.project === null" title="Dodajte projekat"
                                          class=" badge badge-success project-preview text-wrap ">Nema projekta</span>

                                </div>
                                <app-avatar
                                        [personalStyle]="task.type==='meeting'? 'margin-top:4px;border: 2px solid white;left: 3%;':'margin-top:4px'"
                                        [avatarWidth]="30" [assigned]="assign"
                                        *ngFor="let assign of task.assigned"></app-avatar>

                            </div>
                        </div>
                        <div class="float-right mr-n2">
                        </div>
                        <p style="font-size: 14px;" class="mt-2">{{task.title}}</p>
                        <div class="kanban-card-tags">
<span style="background: #4bc66c" class="badge badge-success ml-1"
      *ngFor="let tag of task.tags">{{tag}}</span>
                        </div>
                    </div>
                    <div
                            class="card-footer no-border bg-transparent kanban-card-attachments no-padding-left text-right no-padding-right">
                        <div id="homethumbs">
                            <div class="wrap">
                                <div class="homethumb">
                                    <button type="button" class="btn btn-link no-padding" *ngIf="task.play===false"
                                            style="margin: 0;"
                                            (click)="taskActivity('play', task)">
                                        <i class="fa fa-play">

                                        </i>
                                    </button>
                                    <button
                                            type="button" class="btn btn-link no-padding" *ngIf="task.play===true"
                                            style="margin: 0;"
                                            [disabled]="task.track !=='inprogress' || buttonDisabled"
                                            (click)="taskActivity('stop', task)">
                                        <i class="fa fa-pause">
                                        </i>
                                    </button>
                                </div>
                                <div class="homethumb">
<span title="Podzadaci"
      (click)="show(task)"
      class="badge badge-info ml-1"
      style="margin-top: 2px;margin-right: 5px;">
<i class="lni lni-list"></i>
    {{task.subtasks.length}}
</span>
                                </div>
                                <div class="homethumb">
<span title="Dokumenti" class="badge badge-success"> <i
        class="lni lni-paperclip"></i> {{task.attachments.length}}</span>
                                </div>

                                <div class="homethumb">
<span title="Komentari" class="badge badge-success ml-1"> <i
        class="lni lni-comments"></i> {{task.comments}}</span>
                                </div>
                                <div class="homethumb">
<span *ngIf="task.dayPast <0" title="Rok je istekao pre {{task.dayPast * -1}} dana"
      class="badge badge-danger ml-1"
      style="margin-top: 2px;pointer-events: none;background: #f4433685;">
{{task.deadline | date: "dd.MM" }}
</span>
                                    <span *ngIf="task.dayPast > 0" title="{{task.dayPast}} dana do kraja roka"
                                          class="badge badge-success ml-1 mr-1"
                                          style="margin-top: 2px;pointer-events: none">
{{task.deadline | date: "dd.MM" }}
</span>
                                    <span *ngIf="task.dayPast == 0" title=" Danas ističe rok."
                                          class="badge badge-info ml-1"
                                          style="margin-top: 2px;pointer-events: none">
{{task.deadline | date: "dd.MM" }}
</span>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="col-md-12 col-xs-12 text-right wd-notif-blc-sep-label "
                         style="padding-right: 6px;">Broj: {{task.identifier}}</div>
                    <div *ngIf="task.visibility" class="com-md-12 cursor">
                        <div *ngIf="task.subtasks.length > 0">
                            <div style="max-height: 200px;" [routerLink]="['/view-task', st._id]"
                                 class="well-done-task-subtasks mt-0 col-md-12"
                                 *ngFor="let st of task.subtasks">

                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item no-padding">
                                        <div style="word-break: break-word;margin-top: 3px;"
                                             class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10   px-0">
                                            <i *ngIf="st.status=='todo'"
                                               style="color:#8a9e74"
                                               title="Otvoren"
                                               class="fa fa-list-ul" aria-hidden="true">
                                            </i>
                                            <i style="color:#0085ff" *ngIf="st.status=='inprogress'"
                                               title="U radu"
                                               class="fa fa-spinner" aria-hidden="true">
                                            </i>
                                            <i style="color:#45f02f"
                                               *ngIf="st.status=='ddone'"
                                               title="Završen"
                                               class="fa fa-check-circle" aria-hidden="true">
                                            </i>
                                            <i style="color:#ff1700"
                                               *ngIf="st.status=='canceled'"
                                               title="Otkazan"
                                               class="fa fa-times" aria-hidden="true">
                                            </i>
                                            <i style="color:#ffd600"
                                               *ngIf="st.status=='postponed'"
                                               title="Odložen"
                                               class="fa fa-clock" aria-hidden="true">
                                            </i>
                                            {{st.title}}
                                        </div>
                                        <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 no-padding"
                                             style="margin-bottom: 8px;margin-top:3px">
                                            <app-avatar [avatarWidth]="23" [assigned]="st.assignedUserData[0]">

                                            </app-avatar>
                                        </div>
                                </ul>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div style="padding-left: 20px;padding-right: 18px;" class="col-md-12 col-sm-12 col-lg-12 col-xl-4">
            <div class="col-md-12 no-padding" class="kanban-header kanban-header-green">
                <div class="media">

                    <div class="media-body"><i class="kanban-header-menu fas fa-ellipsis-v"></i>
                        <h3 class="mt-0 mb-0 kanban-header-label">ZAVRŠENI</h3>
                        <p class="kanban-header-desc">Zadaci koji su u završeni: {{tracks[2].tasks.length}}</p>
                    </div>
                </div>

            </div>

            <div class="card-list-content mt-3" cdkDropList [id]="tracks[2].id"
                 [cdkDropListData]="tracks[2].tasks"
                 [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">
                <!--Kanban card -->
                <div *ngFor="let task of tracks[2].tasks" cdkDrag [cdkDragDisabled]="task.track==='ddone'"
                     class="card mb-3 kanban-card"
                     [ngStyle]="{'border': task['validation_returns'] >0  ?'3px solid #f4433685':''}">
                    <div [routerLink]="['/view-task',task._id]"
                         class="card-body">
                        <div class="float-right mt-n1 mb-2" style="width: 100%">
                            <div class="media">
                                <div class="media-body" style="margin-top:2px;">
<span id="projectSpan" *ngIf="task.project !== null"
      class=" badge badge-success project-preview text-wrap">{{task.project.name}}</span>
                                    <span id="projectSpan" *ngIf="task.project === null" title="Dodajte projekat"
                                          class=" badge badge-success project-preview text-wrap ">Nema projekta</span>

                                </div>
                                <app-avatar
                                        [personalStyle]="task.type==='meeting'? 'margin-top:4px;border: 2px solid white;left: 3%;':'margin-top:4px'"
                                        [avatarWidth]="30" [assigned]="assign"
                                        *ngFor="let assign of task.assigned"></app-avatar>

                            </div>
                        </div>
                        <div class="float-right mr-n2">
                        </div>
                        <p style="font-size: 14px;" class="mt-2">{{task.title}}</p>
                        <div class="kanban-card-tags">
<span style="background: #4bc66c" class="badge badge-success ml-1"
      *ngFor="let tag of task.tags">{{tag}}</span>
                        </div>
                    </div>
                    <div
                            class="card-footer no-border bg-transparent kanban-card-attachments no-padding-left text-right no-padding-right">
                        <div id="homethumbs">
                            <div class="wrap">

                                <div class="homethumb">
<span title="Podzadaci"
      (click)="show(task)"
      class="badge badge-info ml-1"
      style="margin-top: 2px;margin-right: 5px;">
<i class="lni lni-list"></i>
    {{task.subtasks.length}}
</span>
                                </div>
                                <div class="homethumb">
<span title="Dokumenti" class="badge badge-success"> <i
        class="lni lni-paperclip"></i> {{task.attachments.length}}</span>
                                </div>
                                <div class="homethumb">
<span title="Komentari" class="badge badge-success ml-1"> <i
        class="lni lni-comments"></i> {{task.comments}}</span>
                                </div>
                                <div class="homethumb">
<span *ngIf="task.dayPast <0" title="Rok je istekao pre {{task.dayPast * -1}} dana"
      class="badge badge-danger ml-1"
      style="margin-top: 2px;pointer-events: none;background: #f4433685;">
{{task.deadline | date: "dd.MM" }}
</span>
                                    <span *ngIf="task.dayPast > 0" title="{{task.dayPast}} dana do kraja roka"
                                          class="badge badge-success ml-1 mr-1"
                                          style="margin-top: 2px;pointer-events: none">
{{task.deadline | date: "dd.MM" }}
</span>
                                    <span *ngIf="task.dayPast == 0" title=" Danas ističe rok."
                                          class="badge badge-info ml-1"
                                          style="margin-top: 2px;pointer-events: none">
Danas
</span>
                                </div>
                            </div>


                        </div>


                    </div>
                    <div class="col-md-12 col-xs-12 text-right wd-notif-blc-sep-label "
                         style="padding-right: 6px;">Broj: {{task.identifier}}</div>
                    <div *ngIf="task.visibility" class="com-md-12 cursor">
                        <div *ngIf="task.subtasks.length > 0">
                            <div style="max-height: 200px;" [routerLink]="['/view-task', st._id]"
                                 class="well-done-task-subtasks mt-0 col-md-12"
                                 *ngFor="let st of task.subtasks">

                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item no-padding">
                                        <div style="word-break: break-word;margin-top: 3px;"
                                             class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10   px-0">
                                            <i *ngIf="st.status=='todo'"
                                               style="color:#8a9e74"
                                               title="Otvoren"
                                               class="fa fa-list-ul" aria-hidden="true">
                                            </i>
                                            <i style="color:#0085ff" *ngIf="st.status=='inprogress'"
                                               title="U radu"
                                               class="fa fa-spinner" aria-hidden="true">
                                            </i>
                                            <i style="color:#45f02f"
                                               *ngIf="st.status=='ddone'"
                                               title="Završen"
                                               class="fa fa-check-circle" aria-hidden="true">
                                            </i>
                                            <i style="color:#ff1700"
                                               *ngIf="st.status=='canceled'"
                                               title="Otkazan"
                                               class="fa fa-times" aria-hidden="true">
                                            </i>
                                            <i style="color:#ffd600"
                                               *ngIf="st.status=='postponed'"
                                               title="Odložen"
                                               class="fa fa-clock" aria-hidden="true">
                                            </i>
                                            {{st.title}}
                                        </div>
                                        <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 no-padding"
                                             style="margin-bottom: 8px;margin-top:3px">
                                            <app-avatar [avatarWidth]="23" [assigned]="st.assignedUserData[0]">

                                            </app-avatar>
                                        </div>
                                </ul>


                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
</div>


<div *ngIf="kanbanList==true && loader==true" id="lista" class="board" cdkDropList [cdkDropListData]="tracks"
     (cdkDropListDropped)="onTrackDrop($event)"
     cdkDropListOrientation="vertical">

    <div cdkDropList
         [id]="tracks[0].id"
         [cdkDropListData]="tracks[0].tasks"
         [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)"
         class="row mt-3 col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12 pr-0 pointer"
         style="min-height: 70px">
        <div class="px-0 d-flex col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 px-0">
                <div id="openTodos" [ngClass]="{'rotate-span-down':listButtons.todo}" class="d-inline-block ml-1"><span
                        (click)="listButtons.todo=!listButtons.todo;openTasksSectionHandler('todo')" style="cursor:pointer;font-size: 20px;
    color: #864ad0;"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></span></div>
                <div class="d-inline ml-2 container kanban-header kanban-header-purple d-inline font-weight-bold">NOVI
                </div>
            </div>
            <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

            <div *ngIf="listButtons.todo" class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head">
                Projekat
            </div>
            <div *ngIf="listButtons.todo" class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head">
                Izvrsilac
            </div>
            <div *ngIf="listButtons.todo"
                 class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 float-right list-head pr-3 text-center">Komentari
            </div>
            <div *ngIf="listButtons.todo" class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 float-right list-head"
                 style="    left: -1%;">
                Rok
            </div>
        </div>


        <div style="min-height: 38px" class="full-width mt-2"
             cdkDropList
             [id]="tracks[0].id"
             [cdkDropListData]="tracks[0].tasks"
             [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">
            <div [ngClass]="{ 'd-none': !listButtons.todo, 'd-initial': listButtons.todo}">
                <div cdkDrag
                     [cdkDragDisabled]="task.track==='ddone'"
                     class="mt-2 d-flex align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-sm-3 pr-md-3  list-card"
                     [ngStyle]="{'border': task['validation_returns'] >0  ?'3px solid #f4433685':''}"
                     *ngFor="let task of tracks[0].tasks"
                >
                    <div [routerLink]="['/view-task',task._id]"
                         class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 pl-1 py-1 font-weight-500 cursor">
                        {{task.title}}
                        <p class="my-0 wd-notif-blc-sep-label">Broj: {{task.identifier}}</p>
                    </div>
                    <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

                    <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head-details">
                    <span *ngIf="task.project !== null"
                          class=" badge badge-success project-preview text-wrap">{{task.project.name}}</span>
                        <span id="projectSpan" *ngIf="task.project === null" title="Dodajte projekat"
                              class=" badge badge-success project-preview text-wrap ">Nema projekta</span>
                    </div>
                    <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right "
                         [ngStyle]="{'left': task.type==='meeting' ? '2%':''}"
                         [ngClass]="{'d-flex':task.type==='meeting'}">
                        <app-avatar [avatarWidth]="task.type==='meeting'? 29:30"
                                    *ngFor="let assign of task.assigned"

                                    [personalStyle]="task.type==='meeting'? 'margin-left: -10px;border: 2px solid white;left: 2%;':'left: 33%;'"
                                    [assigned]="assign"></app-avatar>
                    </div>

                    <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 text-center list-head">
                        <span title="{{task.comments!==0? 'Ukupan broj komentara na zadatku '+ task.comments: 'Nema komentara.'}}">{{task.comments == 0 ? '' : task.comments}}
                            <img style="width: 20px" src="assets/icons/comments.png"> </span>
                    </div>
                    <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 mt-1 float-right list-head-details"
                         [title]=" task.type==='task'? (task.deadline | date: 'dd.MM.yyyy HH:mm'): (task.meeting_time.start | date: 'dd.MM.yyyy HH:mm')"
                    ><span><i
                            class="lni lni-calendar"></i></span> {{task.type === 'task' ? task.deadlineString : task.meetingStart}}
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div cdkDropList
         [id]="tracks[1].id"
         [cdkDropListData]="tracks[1].tasks"
         [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)"
         class="row mt-3 col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12 pr-0 pointer"
         style="min-height: 70px">
        <div class="px-0 d-flex col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 px-0">
                <div id="openInprogress" [ngClass]="{'rotate-span-down':listButtons.inprogress}"
                     class="d-inline-block ml-1"><span
                        (click)="listButtons.inprogress=!listButtons.inprogress;openTasksSectionHandler('inprogress')"
                        style="cursor:pointer;font-size: 20px;
    color: #ffab2e;"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></span></div>
                <div class="d-inline ml-2 container kanban-header kanban-header-orange d-inline font-weight-bold">U RADU
                </div>
            </div>
            <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

            <div *ngIf="listButtons.inprogress" class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head">
                Projekat
            </div>
            <div *ngIf="listButtons.inprogress" class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head">
                Izvrsilac
            </div>
            <div *ngIf="listButtons.inprogress"
                 class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 float-right list-head pr-3 text-center">Komentari
            </div>
            <div *ngIf="listButtons.inprogress" class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 float-right list-head"
                 style="    left: -1%;">
                Rok
            </div>
        </div>


        <div style="min-height: 38px" class="full-width mt-2"
             cdkDropList
             [id]="tracks[1].id"
             [cdkDropListData]="tracks[1].tasks"
             [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">
            <div class="row mx-2" [ngClass]="{ 'd-none': !listButtons.inprogress, 'd-initial': listButtons.inprogress}">
                <div cdkDrag
                     [cdkDragDisabled]="task.track==='ddone'"
                     class="mt-2 d-flex align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-sm-3 pr-md-3  list-card"
                     [ngStyle]="{'border': task['validation_returns'] >0  ?'3px solid #f4433685':''}"
                     *ngFor="let task of tracks[1].tasks"
                >
                    <div class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 pl-1 py-1 font-weight-500">
                        <div class="homethum">
                            <button [routerLink]="[]" type="button" class="btn btn-link no-padding"
                                    *ngIf="task.play===false"
                                    style="margin: 0;"
                                    [ngStyle]="{'vertical-align': task.title.length> 46?'top':''}"
                                    (click)="taskActivity('play', task);$event.preventDefault()">
                                <i class="fa fa-play">

                                </i>
                            </button>
                            <button [routerLink]="[]"
                                    type="button" class="btn btn-link no-padding" *ngIf="task.play===true"
                                    style="margin: 0;"
                                    [ngStyle]="{'vertical-align': task.title.length> 46?'top':''}"
                                    [disabled]="task.track !=='inprogress' || buttonDisabled"
                                    (click)="taskActivity('stop', task);$event.preventDefault()">
                                <i class="fa fa-pause">
                                </i>
                            </button>
                            <label style="width: 85%;" class="ml-1 cursor"
                                   [routerLink]="['/view-task',task._id]">  {{task.title}}</label>

                            <p class="my-0 wd-notif-blc-sep-label"
                               [routerLink]="['/view-task',task._id]">
                                Broj: {{task.identifier}}</p>
                        </div>
                    </div>
                    <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

                    <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head-details">
                    <span *ngIf="task.project !== null"
                          class=" badge badge-success project-preview text-wrap">{{task.project.name}}</span>
                        <span id="projectSpan" *ngIf="task.project === null" title="Dodajte projekat"
                              class=" badge badge-success project-preview text-wrap ">Nema projekta</span>
                    </div>
                    <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right "
                         [ngStyle]="{'left': task.type==='meeting' ? '2%':''}"
                         [ngClass]="{'d-flex':task.type==='meeting'}">
                        <app-avatar [avatarWidth]="task.type==='meeting'? 29:30"
                                    *ngFor="let assign of task.assigned"

                                    [personalStyle]="task.type==='meeting'? 'margin-left: -10px;border: 2px solid white;left: 2%;':'left: 33%;'"
                                    [assigned]="assign"></app-avatar>
                    </div>

                    <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 text-center list-head">
                        <span title="{{task.comments!==0? 'Ukupan broj komentara na zadatku '+ task.comments: 'Nema komentara.'}}">
                            {{task.comments == 0 ? '' : task.comments}}
                            <img style="width: 20px" src="assets/icons/comments.png"> </span>
                    </div>
                    <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 mt-1 float-right list-head-details"
                         [title]=" task.type==='task'? (task.deadline | date: 'dd.MM.yyyy HH:mm'): (task.meeting_time.start | date: 'dd.MM.yyyy HH:mm')"
                    ><span><i
                            class="lni lni-calendar"></i></span> {{task.type === 'task' ? task.deadlineString : task.meetingStart}}
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div cdkDropList
         [id]="tracks[2].id"
         [cdkDropListData]="tracks[2].tasks"
         [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)"
         class="row mt-3 col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12 pr-0 pointer"
         style="min-height: 70px">
        <div class="px-0 d-flex col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 px-0">
                <div id="openDdone" [ngClass]="{'rotate-span-down':listButtons.ddone}" class="d-inline-block ml-1"><span
                        (click)="listButtons.ddone=!listButtons.ddone;openTasksSectionHandler('ddone')" style="cursor:pointer;font-size: 20px;
    color: #4bc66c;"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></span></div>
                <div class="d-inline ml-2 container kanban-header kanban-header-green d-inline font-weight-bold">
                    ZAVRŠENI
                </div>
            </div>
            <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

            <div *ngIf="listButtons.ddone" class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head">
                Projekat
            </div>
            <div *ngIf="listButtons.ddone" class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head">
                Izvrsilac
            </div>
            <div *ngIf="listButtons.ddone"
                 class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 float-right list-head pr-3 text-center">Komentari
            </div>
            <div *ngIf="listButtons.ddone" class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 float-right list-head"
                 style="    left: -1%;">
                Rok
            </div>
        </div>


        <div style="min-height: 38px" class="full-width mt-2"
             cdkDropList
             [id]="tracks[2].id"
             [cdkDropListData]="tracks[2].tasks"
             [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">
            <div class="row mx-2" [ngClass]="{ 'd-none': !listButtons.ddone, 'd-initial': listButtons.ddone}">
                <div cdkDrag
                     [cdkDragDisabled]="task.track==='ddone'"
                     class="mt-2 d-flex align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-sm-3 pr-md-3  list-card"
                     *ngFor="let task of tracks[2].tasks"
                     [ngStyle]="{'border': task['validation_returns'] >0  ?'3px solid #f4433685':''}"
                >
                    <div [routerLink]="['/view-task',task._id]"
                         class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 pl-1 py-1 font-weight-500 cursor">
                        {{task.title}}
                        <p class="my-0 wd-notif-blc-sep-label">Broj: {{task.identifier}}</p>
                    </div>
                    <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

                    <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right list-head-details">
                    <span *ngIf="task.project !== null"
                          class=" badge badge-success project-preview text-wrap">{{task.project.name}}</span>
                        <span id="projectSpan" *ngIf="task.project === null" title="Dodajte projekat"
                              class=" badge badge-success project-preview text-wrap ">Nema projekta</span>
                    </div>
                    <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 float-right "
                         [ngStyle]="{'left': task.type==='meeting' ? '2%':''}"
                         [ngClass]="{'d-flex':task.type==='meeting'}">
                        <app-avatar [avatarWidth]="task.type==='meeting'? 29:30"
                                    *ngFor="let assign of task.assigned"

                                    [personalStyle]="task.type==='meeting'? 'margin-left: -10px;border: 2px solid white;left: 2%;':'left: 33%;'"
                                    [assigned]="assign"></app-avatar>
                    </div>

                    <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 text-center list-head">
                        <span title="{{task.comments!==0? 'Ukupan broj komentara na zadatku '+ task.comments: 'Nema komentara.'}}">{{task.comments == 0 ? '' : task.comments}}
                            <img style="width: 20px" src="assets/icons/comments.png"> </span>
                    </div>
                    <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 mt-1 float-right list-head-details"
                         [title]=" task.type==='task'? (task.deadline | date: 'dd.MM.yyyy HH:mm'): (task.meeting_time.start | date: 'dd.MM.yyyy HH:mm')"
                    ><span><i
                            class="lni lni-calendar"></i></span> {{task.type === 'task' ? task.deadlineString : task.meetingStart}}
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>


<script>export default {
    components: {}
}
</script>
